export default __webpack_public_path__ + "static/media/danji_cg_01_big.c25bb439.jpg";